var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"items":_vm.availableBusinessProcesses,"label":_vm.label,"menu-props":{ contentClass: 'custom-scrollbar' },"item-text":_vm.itemText,"item-value":_vm.itemValue,"value":_vm.value},on:{"change":_vm.onValueChange},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var on = ref.on;
var attrs = ref.attrs;
return [_vm._t("bp-list-item",null,{"item":item,"on":on,"attrs":attrs})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }